import registerHtml from './register.component.html';
import './register.component.scss';

class RegisterController {
    constructor($scope, $window, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.$sce = $sce;
        this.shopPaymentCountries = $window.shopPaymentCountries;
        this.red = '';
        this.referringUserHash = '';
        this.data = {
            newsletter: false,
            terms: false,
            companyName: '',
            firstName: '',
            lastName: '',
            email: '',
            emailConfirm: '',
            phone: '',
            taxNumber: '',
            noTaxNumber: false,
            icoNumber: '',
            address: '',
            city: '',
            zipCode: '',
            country: '',
            invoice: '0',
            password: '',
            passwordConfirm: ''
        };
        this.tmpData = null;
        this.showAllErrors = false;
        this.form = null;
        this.emailConfirmationPattern = null;
        this.passwordConfirmationPattern = null;
    }

    $onInit() {
        if (this.tmpData !== null && this.tmpData !== '') {
            this.data = JSON.parse(this.tmpData);
    
            if (this.data.phone && !isNaN(this.data.phone)) {
                this.data.phone = parseInt(this.data.phone, 10);
            }
        }

        if (this.data.country === '') {
            this.data.country = this.shopCountry;
        }

        this.$scope.$watch(() => this.data, (newVal, oldVal) => {
            if (newVal.invoice !== oldVal.invoice && newVal.invoice === '0') {
                this.data.taxNumber = '';
            }
        }, true);

        this.$scope.$watch(() => this.data.noTaxNumber, (newVal, oldVal) => {
            if (parseInt(newVal) === 1) {
                this.data.taxNumber = null;
            }
        }, true);

        this.$scope.$watch(() => this.data.invoice, (newVal, oldVal) => {
            if (newVal === '0') {
                this.data.taxNumber = null;
            }
        });

        this.$scope.$watch(() => this.data.country, (newVal, oldVal) => {
            if (this.$scope.$ctrl.form) {
                for (let $$control of this.$scope.$ctrl.form.$$controls) {
                    if ($$control.$name === 'invoiceTaxNumber') {
                        $$control.$setDirty();
                        $$control.$validate();
                    }
                }
            }
        }, true);

        this.$scope.taxNumberPattern = (() => {
            let patterns = {
                4: [/^(CZ\d{8,10})?$/, /^[A-Z]{2}\d{5,18}$/],
                5: /^(ATU)?[0-9]{8}$/
            };

            return {
                test: (value) => {
                    if (patterns[this.shopId]) {
                        switch(this.shopId) {
                            case 4:
                                if (this.data.country === 'CZ') {
                                    return patterns[this.shopId][0].test(value);
                                }

                                return patterns[this.shopId][1].test(value);
                            case 5:
                                if (this.data.country === 'AT') {
                                    return patterns[this.shopId].test(value);
                                }

                                return true;
                        }
                    } else {
                        return true;
                    }
                }
            };
        })();

        this.$scope.$watch(() => this.data.email, (newVal, oldVal) => {
            if (newVal) {
                this.emailConfirmationPattern = new RegExp('^' + newVal + '$');
            }
        });

        this.$scope.$watch(() => this.data.password, (newVal, oldVal) => {
            if (newVal) {
                const escapedPassword = this.escapeRegExp(newVal);
                this.passwordConfirmationPattern = new RegExp('^' + escapedPassword + '$');
            }
        });
    }

    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    submitForm() {
        this.updateHiddenField();

        this.form.terms.$setValidity('required', !!this.data.terms);
        this.form.terms.$setTouched();
        if (this.form.$valid) {
            document.getElementById('registerForm').submit();
        }
    }

    updateHiddenField() {
        document.getElementById('hiddenInvoice').value = this.data.invoice;
        document.getElementById('hiddenNoTaxNumber').value = this.data.noTaxNumber;
        document.getElementById('hiddenNewsletter').value = this.data.newsletter;
    }

    getAddressPattern() {
        return '^(?=.*[A-Za-z])(?=.*\\d).+$';
    }

    getEmailConfirmationPattern() {
        return this.emailConfirmationPattern;
    }

    getPasswordConfirmationPattern() {
        return this.passwordConfirmationPattern;
    }

    test() {
        this.form.$$setSubmitted();
    }

    get postUrl() {
        let postUrl = '/users/register';

        if (this.red !== '') {
            postUrl = postUrl + '?red=' + this.red;
        }

        return postUrl;
    }

    get shopId() {
        return window.shopId;
    }

    get shopCountry() {
        return window.shopCountry;
    }

    get isNameRequired() {
        return this.shopId === 2 ||
            this.shopId === 5 ||
            this.data.invoice === '0' ||
            this.data.invoice === '1' && (
                !this.data.companyName ||
                this.data.companyName && this.data.companyName.length === 0 ||
                !this.data.taxNumber ||
                this.data.taxNumber && this.data.taxNumber.length === 0
            )
    }

    get isCompanyNameRequired() {
        return this.data.invoice === '1';
    }

    get isTaxNumberRequired() {
        return !(
            this.data.invoice === '0' ||
            this.shopId === 2 ||
            this.shopId === 5 && this.data.noTaxNumber === true ||
            this.shopId === 4 && this.data.country === 'CZ'
        );
    }

    get isTaxNumberInputDisplayed() {
        return this.data.invoice === '1';
    }

    get isTaxNumberRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && this.isTaxNumberRequired;
    }

    get isTaxNumberNotRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && !this.isTaxNumberRequired;
    }

    get isIcoNumberInputDisplayed() {
        return this.data.invoice === '1' && this.shopId === 4;
    }

    get isIcoNumberInputRequired() {
        return this.data.country === 'CZ';
    }

    get isIcoNumberRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && this.isIcoNumberInputRequired;
    }

    get isIcoNumberNotRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && !this.isIcoNumberInputRequired;
    }
}

let registerComponent = {
    bindings: {
        'red': '@',
        'referringUserHash': '@',
        'tmpData': '@'
    },
    template: registerHtml,
    controller: RegisterController
}

export default registerComponent;
